module.exports = __webpack_public_path__ + "img/kowshik-pal.78a7d805.jpeg";